import {useQuery} from "@tanstack/react-query";
import {getLotteryGamesService} from "../services/getLotteryGames.service";

/**
 * Hook to fetch and cache lottery games data
 * Provides all games with their draws, figures, providers, and configuration
 */
const useGetLotteryGames = () => {
  return useQuery({
    queryKey: ["lottery-games"],
    queryFn: getLotteryGamesService,
    staleTime: 5 * 60 * 1000, // 5 minutes
    gcTime: 10 * 60 * 1000, // 10 minutes
    refetchOnWindowFocus: false,
  });
};

export default useGetLotteryGames;
